import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IOption {
	name: string;
	id: number;
	value: string;
}
export interface IDict {
	major_cates: IOption[];

	country: IOption[];
	school_type: IOption[];
	tutor_type: IOption[];
	stage: IOption[];
	subject: IOption[];
	case_type: IOption[];
	tag: IOption[];
	series: IOption[];
	xingzhi: IOption[];
	xinwen: IOption[];

	schooltests: IOption[];
}

const initialState: IDict = {
	major_cates: [],
	country: [],
	school_type: [],
	tutor_type: [],
	stage: [],
	subject: [],
	case_type: [],
	tag: [],
	series: [],
	schooltests: [],
	xingzhi: [],
	xinwen: [],
}

export const dict = createSlice({
	name: 'dict',
	initialState,
	reducers: {
		setCountry: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.country = actions.payload
		},
		setMajorCate: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.major_cates = actions.payload
		},
		setCaseType: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.case_type = actions.payload
		},
		setSchoolType: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.school_type = actions.payload
		},
		setTutorType: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.tutor_type = actions.payload
		},
		setStage: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.stage = actions.payload
		},
		setSubject: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.subject = actions.payload
		},
		setTag: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.tag = actions.payload
		},
		setSeries: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.series = actions.payload
		},
		//直通车学校初级
		setSchoolTest: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.schooltests = actions.payload
		},
		//办学性质
		setXingzhi: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.xingzhi = actions.payload
		},
		//新闻类型
		setXinwen: (state: IDict, actions: PayloadAction<IOption[]>) => {
			state.xinwen = actions.payload
		},
	}
})

export const { setCountry, setMajorCate, setCaseType, setSchoolType, setTutorType, setStage, setSubject, setTag, setSeries, setSchoolTest, setXingzhi, setXinwen } = dict.actions

export default dict.reducer